export const SET_USER_PAGINATED_REPORTS_LOADED = "SET_USER_PAGINATED_REPORTS_LOADED";

export const setUserPaginatedReportsLoaded = (userPaginatedReportsLoaded: boolean) => {
  return {
    userPaginatedReportsLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_PAGINATED_REPORTS_LOADED
  };
};
